import { Link } from '@tanstack/react-router'
import { useGetModule } from '@/services/modulesService'
import { useModulesStore } from '@/stores/useModulesStore'
import { cn } from '@/lib/utils'
import { Card, CardContent } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import PageTitle from '@/components/PageTitle'
import { Main } from '@/components/layout/main'

const ModuleTests = () => {
  const { setSelectedModule } = useModulesStore()
  // const [page, setPage] = useState(1)

  const { modules } = useGetModule()

  // const handlePageChange = (page: number) => {
  //   setPage(page)
  // }

  return (
    <Main>
      <PageTitle title='Test Management'></PageTitle>
      <div className=''>
        <Card className='py-1'>
          <CardContent className='p-0'>
            <div className='px-4 pt-5'>
              <PageTitle title='Module List'></PageTitle>
            </div>
            <Table>
              <TableHeader>
                <TableRow className='bg-[#F2F4F7]'>
                  <TableHead className='font-mundial max-w-[30%] p-4 text-sm font-[600] text-[#002652]'>
                    Module name
                  </TableHead>
                  <TableHead className='font-mundial w-[140px] text-center text-sm font-[600] text-[#002652]'>
                    Class
                  </TableHead>
                  <TableHead className='font-mundial w-[140px] text-center text-sm font-[600] text-[#002652]'>
                    Mock Exam
                  </TableHead>

                  <TableHead className='font-mundial w-[140px] text-center text-sm font-[600] text-[#002652]'>
                    Practice Test
                  </TableHead>
                  <TableHead className='font-mundial max-w-[10%] text-center text-sm font-[600] text-[#002652]' />
                </TableRow>
              </TableHeader>
              <TableBody>
                {modules?.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={8} className='h-24 text-center'>
                      No data found.
                    </TableCell>
                  </TableRow>
                )}
                {modules?.map((item) => (
                  <TableRow key={item.id} className='hover:bg-gray-50'>
                    <TableCell className='w-[50%] max-w-[40%] p-4'>
                      <div>
                        <div className='text-sm font-[400] text-[#002652]'>
                          {item.name}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell className='w-[15%] text-center text-sm font-[300] text-[#002652]'>
                      {item.total_classes}
                    </TableCell>
                    <TableCell
                      className={cn(
                        'w-[15%] text-center text-sm font-[300] text-[#002652]'
                      )}
                    >
                      {item.total_mock_exam}
                    </TableCell>
                    <TableCell
                      className={cn(
                        'w-[15%] text-center text-sm font-[300] text-[#002652]'
                      )}
                    >
                      {item.total_practice_test}
                    </TableCell>
                    <TableCell className='w-[5%] px-3 text-center'>
                      <Link
                        to='/test/$moduleId'
                        params={{ moduleId: item.id.toString() }}
                        className='rounded px-6 py-2 text-[#0057B8] hover:bg-[#0057B8]/10'
                        onClick={() => {
                          setSelectedModule(item)
                        }}
                      >
                        View detail
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            {/* <div className='flex justify-end p-4'>
            <TablePaginate
              page={page}
              totalPages={10}
              onPageChange={handlePageChange}
              readOnlyPageDisplay={false}
              hideOnSinglePage={false}
            />
          </div> */}
          </CardContent>
        </Card>
      </div>
    </Main>
  )
}

export default ModuleTests
